export default __webpack_public_path__ + "static/media/webdev.ca32e542.png";